document.addEventListener("DOMContentLoaded", () => {
  const $slider = $('.reviews-list');

  $slider.slick({
    infinite: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    customPaging: function(slider, i) {
      return $('<button>');
    },
    arrows: false,
    responsive: [
      { breakpoint: 1500,  settings: { slidesToShow: 2.5 } },
      { breakpoint: 1100,  settings: { slidesToShow: 1.8 } },
      { breakpoint: 700,  settings: { slidesToShow: 1.2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } },
    ],
  });

  $('#reviews-next-btn').on('click', function() {
    $slider.slick('slickNext');
  });

  $('#reviews-prev-btn').on('click', function() {
    $slider.slick('slickPrev');
  });

  $('#reviews-next-btn-mobile').on('click', function() {
    $slider.slick('slickNext');
  });

  $('#reviews-prev-btn-mobile').on('click', function() {
    $slider.slick('slickPrev');
  });

  $slider.on('afterChange', function(event, slick, currentSlide) {
    // Calculate the last possible slide index
    // When showing 2.5 slides, the last slide can start at different positions
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    // For prev button - disable only when at absolute first slide
    if (currentSlide === 0) {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-prev-btn').prop('disabled', false);
      $('#reviews-prev-btn-mobile').prop('disabled', false);
    }

    // For next button - disable when at or beyond the last possible slide
    if (currentSlide >= lastPossibleSlide) {
      $('#reviews-next-btn').prop('disabled', true);
      $('#reviews-next-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-next-btn').prop('disabled', false);
      $('#reviews-next-btn-mobile').prop('disabled', false);
    }

    console.log('Current Slide:', currentSlide, 'Last Possible:', lastPossibleSlide);
  });

  // Also check on beforeChange to handle edge cases
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    // Prevent going beyond the last slide
    if (nextSlide > lastPossibleSlide) {
      return false; // Prevent the slide change
    }
  });

  // Initial check
  $slider.on('init', function(event, slick) {
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    if (slick.slideCount <= slidesToShow) {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
      $('#reviews-next-btn').prop('disabled', true);
      $('#reviews-next-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
      $('#reviews-next-btn').prop('disabled', false);
      $('#reviews-next-btn-mobile').prop('disabled', false);
    }
  });

  // Trigger initial state
  setTimeout(() => {
    $slider.slick('slickGoTo', 0, false);
  }, 100);

  $('.reviews-list').height('auto');
});
